// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4487":"a337a090","5916":"6dc413d6"}[chunkId] + ".chunk.css";
};